<template>
    <div class="main">
        <Banner :banner="banner"/>
        <Headlines :headlines="headlines"/>

        <div class="content-box">
            <div class="left-box">
                <Article :article="broadcast"/>
                <Article :article="review"/>
                <Project :project="project"/>
            </div>

            <Rightbox/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'tzlytkn',
    // meta配置
    metaInfo: {
        title: '【专题】' + '水灾 台风 疫情.......天灾下在线旅游为何频现退款难',
        meta: [
            {
                name: 'keywords',
                content: '水灾 台风 疫情 天灾 在线旅游 退款 退票 携程 同程 马蜂窝 去哪儿 驴妈妈 途牛'
            },
            {
                name: 'description',
                content: '近期，河南出现水灾，台风“烟花”影响部分东部沿海地区、疫情局部反弹。面对灾害的影响，携程、同程、马蜂窝、去哪儿、驴妈妈、途牛等旅游平台第一时间发布免费退改等紧急预案。然而，据国内知名网络消费纠纷调解平台“电诉宝”（315.100EC.CN）收到的投诉来看，“言行不一”的平台不在少数。'
            }
        ]
    },
    data() {
        return {
            // 头图标题
            banner: {
                img: require('@/assets/tzlytkn/banner.jpg'),
                title: [
                    '水灾 台风 疫情.......天灾下在线旅游为何频现退款难',
                    '',
                ],
                text: '近期，河南出现水灾，台风“烟花”影响部分东部沿海地区、疫情局部反弹。面对灾害的影响，携程、同程、马蜂窝、去哪儿、驴妈妈、途牛等旅游平台第一时间发布免费退改等紧急预案。然而，据国内知名网络消费纠纷调解平台“电诉宝”（315.100EC.CN）收到的投诉来看，“言行不一”的平台不在少数。'
            },

            // 置顶头条
            headlines: [
                {
                    title: '河南水灾 台风来袭 飞猪 去哪儿 携程等OTA“言行不一”为哪般',
                    url: '/detail--6598649.html'
                },
            ],

            // 滚动播报
            broadcast: {
                title: {
                    topic: '滚动播报',
                    more: {
                        name: '我要投诉>',
                        url: '/Index/complain.html'
                    }
                },
                params: {
                    p: 1,
                    n: 5,
                    terms: '退票'
                },
            },

            // 相关平台
            review: {
                title: {
                    topic: '相关平台',
                    more: {
                        name: '企业库>',
                        url: 'http://cop.100ec.cn/'
                    }
                },
                nav: [
                    {
                        value: '携程 退票',
                        label: '携程'
                    },
                    {
                        value: '去哪儿 退票',
                        label: '去哪儿'
                    },
                    {
                        value: '飞猪 退票',
                        label: '飞猪'
                    },
                    {
                        value: '走着瞧旅行 退款',
                        label: '走着瞧旅行'
                    },
                ],
                params: {
                    p: 1,
                    n: 5,
                    terms: '携程 退票'
                },
            },

            // 相关专题
            project: {
                title: {
                    topic: '相关专题',
                },
                params: {
                    p: 1,
                    name: '监管类',
                    title: '退票'
                },
            }
        }
    },
}
</script>

<style>

</style>
